module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/01-5aa4e647eec99024de9d9afa635a83c0.jpg";